import { REGEX_CAMPI_NUMERICI, REGEX_MAIL } from "./regex";



export const isNotNullUndefined = (value) => {
    if (value === null || value === undefined || value?.trim() === '')
        return {
            value: value,
            error: true,
            messageError: "Campo obbligatorio"
        };
    else
        return {
            value: value,
            error: false,
            messageError: ""
        };
}
export const validateZipCode = (zipCode) => {
    let result = isNotNullUndefined(zipCode);
    if (result.error === true)
        // è un campo obbligatorio: se non è valorizzato, allora ritorno errore
        return result;
    else if (!REGEX_CAMPI_NUMERICI.test(zipCode))
        return {
            value: zipCode,
            error: true,
            messageError: "Il campo non può contenere lettere o caratteri speciali"
        };
    else if (zipCode.length !== 5)
        return {
            value: zipCode,
            error: true,
            messageError: "Il campo deve avere 5 cifre"
        };
    else
        return {
            value: zipCode,
            error: false,
            messageError: ""
        };
}
export const validateMunicipalityCode = (municipalityCode) => {
    let result = isNotNullUndefined(municipalityCode);
    if (result.error === true)
        // è un campo obbligatorio: se non è valorizzato, allora ritorno errore
        return result;
    else if (municipalityCode.length < 5 || municipalityCode.length > 6)
        return {
            value: municipalityCode,
            error: true,
            messageError: "Non valido"
        };
    else
        return {
            value: municipalityCode,
            error: false,
            messageError: ""
        };
}
export const validateAddress = (address) => {
    return isNotNullUndefined(address);
}
export const validateTelefono = (telefono) => {
    return isNotNullUndefined(telefono);
}
export const validateMail = (mail) => {
    let result = isNotNullUndefined(mail);
    if (result.error === true)
        // non è un campo obbligatorio: se la mail non è valorizzata, allora non ritorno errore
        return {
            value: mail,
            error: false,
            messageError: ""
        };
    else if (!REGEX_MAIL.test(mail.toLowerCase()))
        // se la mail è valorizzata, allora controllo che sia valida
        return {
            value: mail,
            error: true,
            messageError: "E-mail non valida"
        };
    else
        return {
            value: mail,
            error: false,
            messageError: ""
        };
}
export const validateCF = (codiceFiscale) => {
    if (codiceFiscale === "" || codiceFiscale.length > 16)
        return {
            value: codiceFiscale,
            error: true,
            messageError: "Codice fiscale non valido"
        };
    else
        return {
            value: codiceFiscale,
            error: false,
            messageError: ""
        };
}
export const validateTS = (tesseraSanitaria) => {
    let result = validateZipCode(tesseraSanitaria);
    if (result.error === true)
        return result;
    else
        return {
            value: tesseraSanitaria,
            error: false,
            messageError: ""
        };
}